import"./UserAvatar.css.ts.vanilla.css";var a="UserAvatar_userAvatarStyles__12xy8f60";export{a as userAvatarStyles};
//# sourceMappingURL=UserAvatar.css.vanilla.js.map
